// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#344E41","footer":"footer_footer__1lZIc"};